import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';
import { getDefaultRouteForRole } from '@/lib/utils/roles';
import type { UserRole } from '@/types/entities';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

export function RoleGuard({ children, allowedRoles }: RoleGuardProps) {
  const { isAuthenticated, getUserRoles } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  const userRoles = getUserRoles();
  
  const hasAccess = userRoles.includes('ADMIN') || 
    allowedRoles.some(role => userRoles.includes(role));

  if (!hasAccess) {
    const redirectPath = getDefaultRouteForRole(userRoles);
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}
